// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import MainApp from './App'; // Asegúrate de que este nombre coincide con el export en App.js
import './index.css'; // Crea este archivo para estilos globales si es necesario

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MainApp />
  </React.StrictMode>
);
